import { createSelector } from 'reselect'
import { getBaseTierOfferWithNoJoiningFee } from 'selectors/luxPlusSelectors'
import { buildEarnKey, LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID } from '@luxuryescapes/lib-lux-loyalty'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from './getIsLoyaltyLuxPlusRenewalBonusEnabled'

export const getLuxPlusSubscriptionInflowPointsCalculationOptions = createSelector(
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item,
  (state: App.State) => getBaseTierOfferWithNoJoiningFee(state),
  (state: App.State) => getIsLoyaltyLuxPlusRenewalBonusEnabled(state),
  (subscriptionItem, baseTierOfferNoFee, isLoyaltyLuxPlusRenewalBonusEnabled): App.LoyaltyPointsEarnCalculationRequest | undefined => {
    const price = baseTierOfferNoFee?.price ?? 0

    if (
      !baseTierOfferNoFee?.id ||
      price <= 0
    ) return
    const shouldIncludeEarnKey = isLoyaltyLuxPlusRenewalBonusEnabled && !!subscriptionItem?.isWithinRenewalGracePeriod
    if (!shouldIncludeEarnKey) {
      return {
        price,
        loyaltyProductType: 'lux_plus',
        offerId: baseTierOfferNoFee.id,
        packageId: '',
      }
    }
    return {
      price,
      loyaltyProductType: 'lux_plus',
      earnKey: buildEarnKey([
        ['productType', LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID],
        ['offerId', baseTierOfferNoFee.id],
      ]),
      offerId: baseTierOfferNoFee.id,
      packageId: '',
    }
  },
)

export const getPointsCalculationsByKeys = createSelector(
  (state: App.State) => state.loyalty.pointsEarnCalculations,
  (_state: App.State, pointCalculationKeys: Array<string>) => pointCalculationKeys,
  (pointsCalculator, keys): Array<App.StatefulData<App.LoyaltyPointsEarnCalculation> | undefined> => keys.map(key => pointsCalculator[key]),
)
